import { useLocation, useParams, useSearchParams, useNavigate } from "react-router-dom";
import RSSB_LOGO from "../assets/RSSB_LOGO.jpeg";
import React, { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import { useTable } from 'react-table';
import '../styles/noPrint.css'

const ReturnAcceptancePreview = () => {
const location = useLocation();
const [searchParams] = useSearchParams();
const navigate = useNavigate()

let id = location.state?.id
const [data,setData] = useState([])
const [rowData,setRowData] = useState([])
const token = localStorage.getItem('token')
const [profileDetails, setProfileDetails] = useState(null);
const centerCode = localStorage.getItem('code')
const email = localStorage.getItem('email')
const name = localStorage.getItem('name');
const badgeId = localStorage.getItem('badgeId');

    useEffect(() => {
      if (!token) {
        // Redirect to login page with additional data
        navigate(
          `/?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}&type=issueRequest`
        );
        return;
      }
        const fetchCenterInfo = async () => {
          try {
           
            const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
                params: { code:centerCode },
              headers: {
                'Authorization': `Bearer ${token}`, // Add the JWT token in the header
              },
            });
            setData(response.data[0]);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
    
        fetchCenterInfo();
      }, []);


      
    const fetchProfileDetails = async () => {
        try {
          const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
          setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
        } catch (err) {
          console.error('Error fetching profile details:', err);
          setProfileDetails(null);

        }
      };
      useEffect(() => {
        const fetchRowData = async () => {
          try {
           
           const response = await apiClient.get(`${SERVER_BASE}/viewReturnSlip/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Ensure token is valid
            },
          });
          
            setRowData(response.data);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
    
        fetchRowData();
        fetchProfileDetails();
      }, []);

      const columns = React.useMemo(
        () => [
          { Header: "S.No", Cell: ({ row }) => row.index + 1 },
          {
            Header: 'Item Name',
            accessor: 'itemName',
          },
          {
            Header: 'Returned Quantity',
            accessor: 'returnQuantity',
          },
          {
            Header: 'UOM',
            accessor: 'uom',
          },
          {
            Header: 'Returnable',
            accessor: 'returnable',
          },
          {
            Header: 'Remarks',
            accessor: 'returnRemark',
          },
        ],
        []
      );
    
      const tableInstance = useTable({
        columns,
        data: rowData?.inventory || [],
      });
    
      const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
      } = tableInstance;

    const organization = {
        name: data?.centerName,
        addressLine1: data?.addressLine1,
        addressLine2: data?.addressLine2,
        addressLine3: data?.addressLine3,
        mobile1: data?.mobile1,
        mobile2: data?.mobile2,
        gstin:data?.gstin,
        contactPerson1:data?.contactPerson1,
        contactPerson2:data?.contactPerson2,
        position1:data?.position1,
        position2:data?.position2
    };

    const itemDetails = rowData?.itemDetails || [];
    const remarks = rowData?.remarks || '';
    const footer = 'H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India';

    return (
        <div style={{ margin: 'auto', padding: '18px', fontFamily: 'Arial, sans-serif', maxWidth: '650px' ,fontSize:'12px'}}>
            {/* Header Section */}
            <div className="d-flex justify-content-between mb-3">
                {/* Back Button - Always visible */}
                <button className="btn btn-secondary no-print" onClick={() => window.history.back()}>
                  Back
                </button>
              </div>
              <div className="d-flex justify-content-between align-items-start border-bottom pb-2">
                {/* Left side: Logo and organization details */}
                <div className="d-flex align-items-start">
                  <img src={RSSB_LOGO} alt="Logo" className="me-3" style={{ height: '65px' }} />
                  <div className="text-start">
                    <h6 className="mb-0">{organization?.name}</h6>
                    <p className="mb-0">{organization?.addressLine1}</p>
                    <p className="mb-0">{organization?.addressLine2}</p>
                    <p className="mb-0">{organization?.addressLine3}</p>
                  </div>
                </div>

                {/* Right side: Receiving department, request number, and date */}
                <div className="text-end mt-2" style={{ fontSize: '14px' }}>
                  <h6 className="mb-0 fw-bold">{rowData?.issuingDepartment}</h6>
                  <p className="mb-0">{rowData?.returnAcceptCode}</p>
                  <p className="mb-0">
                    {" "}
                    {rowData?.acceptedDate
                      ? new Intl.DateTimeFormat("en-US", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }).format(new Date(rowData.acceptedDate))
                      : ""}
                  </p>
                </div>
              </div>
              <div className="text-center border-bottom mt-2" style={{ fontSize: '14px', lineHeight: '1.6' }}>
            <h3 className="fw-bold mb-1" style={{ fontSize: '15px' }}>
                RETURN ACCEPTANCE
            </h3>
        </div>
        <div className="mt-3" style={{ fontSize: '16px' }}>
                <div className="d-flex justify-content-between">
                    <p className="mb-0">
                    To : <span className="fw-bold">
                        {rowData?.receivingDepartment}</span> 
                    </p>
                </div>
            </div>
            <table {...getTableProps()} className="table table-bordered table-striped mt-3">
              <thead className="thead-light">
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className='mt-2 d-flex justify-content-between' style={{fontSize: '14px'}}>
                <p className="mb-0">
                    <span className="fw-bold">Remarks: </span> 
                    <span className="">{rowData?.remarks}</span>
                </p>
            </div>

            <div className="mt-2" style={{ fontSize: '14px' }}>
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    {rowData?.returnedBy && <>
                    <p className="mb-1">
                        <span className="fw-bold">Returned By:</span> {rowData?.returnedBy} ({rowData?.returnedByBadge})
                    </p>
                    </>}
                    {rowData?.acceptedBy && <>
                    <p className="mb-1">
                        <span className="fw-bold">Accepted By:</span> {rowData?.acceptedBy} ({rowData?.acceptedByBadge})
                    </p>
                    </>}
                </div>
            </div>
                <p className="text-end mt-2 fw-bold">Signatory</p>
            </div>
            <footer className="footer" style={{
              textAlign: 'center', 
              marginTop: '20px', 
              fontSize: '12px', 
              borderTop: '1px solid black', 
              paddingTop: '10px', 
              fontWeight: 'bolder'
            }}>
              {footer}
            </footer>

            {/* CSS for print media */}
            <style>
              {`
                @media print {
                  .footer {
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    page-break-before: always;
                  }
                }
              `}
            </style>
        </div>
    );
};

export default ReturnAcceptancePreview;
